(function () {
  var root = document.querySelector('[data-ft-root]');
  if (!root) return;

  var tabs = [].slice.call(root.querySelectorAll('[data-ft-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-ft-panel]'));
  var crumbEl = root.querySelector('[data-ft-crumb]');
  var keys = tabs.map(function (t) { return t.getAttribute('data-ft-tab'); });
  var defaultKey = root.getAttribute('data-ft-default') || keys[0];

  var raf = null, rtWait = null;   // RT 動作比較アニメ
  var fxRaf = null, fxWait = null; // 機能別デモアニメ

  function getF() {
    try {
      var f = new URLSearchParams(location.search).get('f');
      if (f && keys.indexOf(f) !== -1) return f;
    } catch (e) {}
    return defaultKey;
  }

  function show(key, push) {
    if (keys.indexOf(key) === -1) key = defaultKey;
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-ft-panel') !== key; });
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-ft-tab') === key;
      t.classList.toggle('is-active', on);
      if (on && crumbEl) {
        var c = t.getAttribute('data-ft-crumb');
        if (c) crumbEl.textContent = c;
      }
    });
    if (push) {
      try { history.replaceState(null, '', '?f=' + key); } catch (e) {}
    }
    stopRT();
    stopFX();
    var active = root.querySelector('[data-ft-panel="' + key + '"]');
    if (active && active.querySelector('[data-ft-reg-fill]')) startRT(active);
    startFX(key);
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      show(t.getAttribute('data-ft-tab'), true);
    });
  });

  // TGL: 長押し / 連打 サブタブ
  [].slice.call(root.querySelectorAll('[data-ft-tgl-mode]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-ft-tgl-mode');
      [].slice.call(root.querySelectorAll('[data-ft-tgl-mode]')).forEach(function (b) {
        b.classList.toggle('is-on', b === btn);
      });
      [].slice.call(root.querySelectorAll('[data-ft-tgl-panel]')).forEach(function (p) {
        p.hidden = p.getAttribute('data-ft-tgl-panel') !== mode;
      });
    });
  });

  window.addEventListener('popstate', function () { show(getF(), false); });
  show(getF(), false);

  // ==================== RT 動作比較アニメ（通常キーボード vs ラピッドトリガー） ====================
  function stopRT() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (rtWait) { clearTimeout(rtWait); rtWait = null; }
  }

  function startRT(scope) {
    stopRT();

    var rf = scope.querySelector('[data-ft-reg-fill]');
    var rc = scope.querySelector('[data-ft-reg-cap]');
    var rs = scope.querySelector('[data-ft-reg-state]');
    var qf = scope.querySelector('[data-ft-rap-fill]');
    var qc = scope.querySelector('[data-ft-rap-cap]');
    var qs = scope.querySelector('[data-ft-rap-state]');
    var qm = scope.querySelector('[data-ft-rap-mark]');
    if (!rf || !qf) { rtWait = setTimeout(function () { startRT(scope); }, 200); return; }

    var ACT = 52, RST = 38;

    function pill(n, on, txt) {
      if (!n) return;
      n.classList.toggle('is-on', !!on);
      n.textContent = txt;
    }
    function draw(f, c, d) {
      f.style.height = d + '%';
      c.style.top = 'calc(' + d + '% - 8px)';
    }

    var seq = [
      { d: 32, sp: 1.5 }, { d: 26, sp: 1.5 }, { d: 24, sp: 0.10 },
      { d: 38, sp: 1.5 }, { d: 31, sp: 1.5 }, { d: 29, sp: 0.10 },
      { d: 90, sp: 1.9 }, { d: 82, sp: 1.5 }, { d: 80, sp: 0.10 },
      { d: 93, sp: 1.7 }, { d: 6, sp: 1.9 }, { d: 1, sp: 0.10 }
    ];
    var si = 0, qd = 0, qActive = false, qDeep = 0;
    var rd = 0, rdir = 1, regActive = false, last = 0;

    function tick(ts) {
      if (ts - last >= 16) {
        last = ts;

        rd += rdir * 1.6;
        if (rd >= 100) { rd = 100; rdir = -1; }
        if (rd <= 0) { rd = 0; rdir = 1; }
        if (!regActive && rdir > 0 && rd >= ACT) regActive = true;
        if (regActive && rdir < 0 && rd <= RST) regActive = false;
        draw(rf, rc, rd);
        rf.style.background = regActive ? '#9a90c4' : '#c4c2cc';
        rc.style.background = regActive ? '#5d508f' : '#9a98a4';
        pill(rs, regActive, regActive ? 'アクティブ（入力中）' : 'リセット（入力なし）');

        var tgt = seq[si].d, step = seq[si].sp, prev = qd;
        if (Math.abs(qd - tgt) <= step) { qd = tgt; si = (si + 1) % seq.length; }
        else qd += qd < tgt ? step : -step;
        var moving = qd - prev;
        if (moving > 0.005) {
          if (qd > qDeep) qDeep = qd;
          if (!qActive && qd >= 6 && qd >= qDeep - 0.2) qActive = true;
        } else if (moving < -0.005) {
          if (qActive && qd <= qDeep - 3) qActive = false;
          if (!qActive) qDeep = qd;
        }
        draw(qf, qc, qd);
        qf.style.background = qActive ? '#7a6caa' : '#c4c2cc';
        qc.style.background = qActive ? '#4a3c78' : '#9a98a4';
        pill(qs, qActive, qActive ? 'アクティブ（入力中）' : 'リセット（入力なし）');
        if (qm) {
          qm.style.top = qd + '%';
          qm.style.opacity = qActive ? '0' : (qd > 8 ? '1' : '0');
        }
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
  }

  // ==================== 機能別デモアニメ（SOCD / Mod-Tap / DKS / Toggle Key） ====================
  function stopFX() {
    if (fxRaf) { cancelAnimationFrame(fxRaf); fxRaf = null; }
    if (fxWait) { clearTimeout(fxWait); fxWait = null; }
  }

  function el(id) { return document.getElementById(id); }

  function cap(node, on) {
    node.setAttribute('style', 'display:flex;align-items:center;justify-content:center;width:46px;height:46px;flex:none;border-radius:10px;font-family:\'Space Grotesk\',sans-serif;font-size:15px;font-weight:700;transition:none;' +
      (on ? 'background:#7a6caa;color:#fff;border:2px solid #6a5c9a;transform:translateY(3px);box-shadow:none;'
          : 'background:#fff;color:#3a3a45;border:2px solid #d8d3e6;transform:none;box-shadow:0 2px 0 #d8d3e6;'));
  }

  function seg(node, on, tone) {
    var c = tone === 'warn' ? ['#c2415a', '#fff', '#a83950'] : ['#5d508f', '#fff', '#4a3c78'];
    node.setAttribute('style', 'flex:1;text-align:center;font-size:12px;font-weight:800;border-radius:8px;padding:8px 4px;' +
      (on ? 'background:' + c[0] + ';color:' + c[1] + ';border:1px solid ' + c[2] + ';'
          : 'background:#eceaf0;color:#5f5f6b;border:1px solid #dcdae2;'));
  }

  function startFX(key) {
    stopFX();
    var maker = { socd: fxSocd, modtap: fxModTap, dks: fxDks, tgl: fxTgl }[key];
    if (!maker) return;
    var tick = maker();
    if (!tick) { fxWait = setTimeout(function () { startFX(key); }, 200); return; }
    var last = 0, t = 0;
    function loop(ts) {
      if (ts - last >= 16) { last = ts; tick(t++); }
      fxRaf = requestAnimationFrame(loop);
    }
    fxRaf = requestAnimationFrame(loop);
  }

  function fxSocd() {
    var na = el('skNa'), nd = el('skNd'), sa = el('skSa'), sd = el('skSd');
    if (!na || !sa) return null;
    var nOut = [el('skNo0'), el('skNo1'), el('skNo2')], sOut = [el('skSo0'), el('skSo1'), el('skSo2')];
    var nNote = el('skNnote'), sNote = el('skSnote');
    var L = 520;
    return function (t) {
      var p = t % L;
      var a = false, d = false, aS = -1, dS = -1;
      if (p < 210) { a = true; aS = 0; }
      if (p >= 60 && p < 150) { d = true; dS = 60; }
      if (p >= 260 && p < 470) { d = true; dS = 260; }
      if (p >= 320 && p < 410) { a = true; aS = 320; }
      cap(na, a); cap(nd, d); cap(sa, a); cap(sd, d);
      var both = a && d;
      var dir = both ? 1 : (a ? 0 : (d ? 2 : 1));
      nOut.forEach(function (n, i) { seg(n, i === dir, both && i === 1 ? 'warn' : ''); });
      var lastK = both ? (aS > dS ? 0 : 2) : dir;
      sOut.forEach(function (n, i) { seg(n, i === lastK, ''); });
      nNote.textContent = both ? '両方入力 → 出力が打ち消され停止' : (a || d ? '入力どおりに移動' : '入力なし');
      sNote.textContent = both ? '後に押した ' + (aS > dS ? 'A' : 'D') + ' を優先 → 止まらない' : (a || d ? '入力どおりに移動' : '入力なし');
    };
  }

  function fxModTap() {
    var key = el('mtKey'), bar = el('mtBar'), tap = el('mtTap'), hold = el('mtHold'), note = el('mtNote');
    if (!key || !bar) return null;
    var TH = 36, L = 300;
    return function (t) {
      var p = t % L;
      var down = false, held = 0;
      if (p < 20) { down = true; held = p; }
      if (p >= 130 && p < 230) { down = true; held = p - 130; }
      cap(key, down);
      var ratio = Math.min(held / 60, 1);
      bar.style.width = (ratio * 100) + '%';
      bar.style.background = held >= TH ? '#7a6caa' : '#b3a8dc';
      var tapOn = !down && p >= 20 && p < 70;
      var holdOn = down && held >= TH;
      seg(tap, tapOn, '');
      seg(hold, holdOn, '');
      note.textContent = holdOn ? '長押し判定 → Ctrl として入力中' : (down ? '押下中（判定待ち）' : (tapOn ? 'タップ判定 → Esc を出力' : '待機'));
    };
  }

  function fxDks() {
    var fill = el('dksFill'), cap2 = el('dksCap'), note = el('dksNote');
    var stem = el('dksStem'), mag = el('dksMag');
    if (!fill || !stem || !mag) return null;
    var lamps = [el('dksL1'), el('dksL2'), el('dksL3'), el('dksL4')];
    var T1 = 40, T2 = 80, L = 400;
    var lit = [false, false, false, false], prev = 0;
    return function (t) {
      var p = t % L;
      var d;
      if (p < 130) d = (p / 130) * 95;
      else if (p < 170) d = 95;
      else if (p < 300) d = 95 - ((p - 170) / 130) * 95;
      else d = 0;
      if (p === 0) lit = [false, false, false, false];
      var up = d > prev;
      if (up && d >= T1) lit[0] = true;
      if (up && d >= T2) lit[1] = true;
      if (!up && lit[1] && d < T2) lit[2] = true;
      if (!up && lit[0] && d < T1) lit[3] = true;
      prev = d;
      fill.style.height = d + '%';
      cap2.style.top = 'calc(' + d + '% - 8px)';
      stem.style.transform = mag.style.transform = 'translateY(' + (d * 0.13) + 'px)';
      fill.style.background = d >= T2 ? '#5d508f' : (d >= T1 ? '#7a6caa' : '#b3a8dc');
      lamps.forEach(function (n, i) { seg(n, lit[i], ''); });
      note.textContent = d >= T2 ? '第2作動点まで押し込み' : (d >= T1 ? '第1作動点を通過' : (up ? '押し込み中' : (d > 1 ? '戻し中' : '全戻し')));
    };
  }

  function fxTgl() {
    var nk = el('tgNk'), tk = el('tgTk');
    var rk = el('tgRk'), ro = el('tgRo'), rn = el('tgRnote');
    if ((!nk || !tk) && !rk) return null;
    var no = el('tgNo'), to = el('tgTo'), nn = el('tgNnote'), tn = el('tgTnote');
    var L = 660;
    return function (t) {
      var p = t % L;
      var down = (p >= 40 && p < 134) || (p >= 386 && p < 480);
      var locked = p >= 40 && p < 480;
      if (nk && tk) {
        cap(nk, down); cap(tk, down);
        seg(no, down, ''); seg(to, locked, '');
        nn.textContent = down ? '押している間だけ前進' : '離すと止まる';
        tn.textContent = locked ? (down && p < 134 ? '1回押して保持ON' : (down ? 'もう一度押して解除' : '指を離しても前進が続く')) : '解除された状態';
      }
      var n2k = el('tgN2k'), n2o = el('tgN2o');
      if (n2k) {
        var manual = p >= 40 && p < 480 && ((p - 40) % 94) < 47;
        cap(n2k, manual);
        seg(n2o, manual, '');
      }
      if (rk) {
        var fire = locked && ((p - 40) % 94) < 47;
        cap(rk, down);
        seg(ro, fire, '');
        rn.textContent = locked ? (down && p < 134 ? '1回押して自動キークリックON' : (down ? 'もう一度押して停止' : '指を離しても自動で入力が続く')) : '解除された状態';
      }
    };
  }
})();
